import { Component, OnInit } from '@angular/core';
import { COMPANIES_ID } from 'projects/common/src/app/enumerables/companies-id';
import { IUser } from 'projects/common/src/app/interfaces';
import { ITableConfig } from 'projects/common/src/app/interfaces/table/table-config';
import { ITableDataParams } from 'projects/common/src/app/interfaces/table/table-data-params';
import { ITableHeaderParams } from 'projects/common/src/app/interfaces/table/table-header-params';
import { CacheService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { TableConfigService } from 'projects/common/src/app/services/table/table-config.service';
import { ExcelExportService } from 'projects/common/src/app/services/utils/excel-export.service';
import { IFilterConfig } from 'src/app/modules/core/interfaces/filter-config';
import { IOutputFilter } from 'src/app/modules/core/interfaces/output-filter';
import { DatePresentationPipe } from 'src/app/modules/core/pipes/date-presentation.pipe';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { ILayoutConfig } from 'src/app/modules/layout/interfaces/layout-config';
import { LayoutConfigService } from 'src/app/modules/layout/services/layout-config.service';
import { ReportTransitService } from '../../services/report-transit.service';

@Component({
  selector: 'app-report-transit',
  templateUrl: './report-transit.component.html',
  styleUrls: ['./report-transit.component.scss'],
})
export class ReportTransitComponent implements OnInit {
  public tableConfig: ITableConfig;
  public filterConfig: IFilterConfig;
  public dataReport: any;
  public params: IOutputFilter;
  public message: string;
  public hasData: boolean;
  public systemError: string;
  public isMtv = false;
  public btnSpinner: boolean;
  public disabledExcelBtn: boolean;

  constructor(
    private layoutConfigService: LayoutConfigService,
    private cacheService: CacheService,
    private reportTransitService: ReportTransitService,
    private tableConfigService: TableConfigService,
    private languageService: LanguageService,
    private datePipe: DatePresentationPipe,
    private googleAnalyticsService: GoogleAnalyticsService,
    private _excelExportService: ExcelExportService,
  ) {
    this.hasData = false;
    const companyId = this.cacheService.local('session').user.company.id;
    this.isMtv = companyId === COMPANIES_ID.MTV;
    this.disabledExcelBtn = false;
    if (this.isMtv) {
      this.filterConfig = {
        dates: { required: true },
        shift: { required: true },
        machineType: { required: true, isForMtv: true },
        machineList: { required: true, multiselect: true },
        cleanButton: true,
      };
    } else {
      this.filterConfig = {
        dates: { required: true },
        shift: { required: true },
        machineType: { required: true, multiselect: true },
        machineList: { required: true, multiselect: true },
        cleanButton: true,
      };
    }
  }

  /**
   * Intialize component
   */
  public ngOnInit(): void {
    const config: ILayoutConfig = {
      title: 'reports',
      subtitle: 'transit',
      imageKey: 'report',
      imageType: 'section',
    };
    this.layoutConfigService.setConfig(config);
  }

  /**
   * get data report Transit
   */
  public async getDataReportTransit($event: IOutputFilter): Promise<void> {
    this.filterConfig.isLoading = true;
    const user = this.cacheService.local('session').user as IUser;
    this.params = {
      startDate: $event.startDate,
      endDate: $event.endDate,
      shiftId: $event.shiftId,
      machineTypeId: $event.machineTypeId,
      machineId: $event.machineId,
      companyId: user.company.id,
    };
    try {
      const response = await this.reportTransitService.getTransitReportData(this.params);
      if (response?.length) {
        this.setTableDetailsConfig(response);
        this.hasData = true;
        this.message = '';
      } else {
        this.hasData = false;
        this.message = this.languageService.message('m034');
      }
      this.systemError = '';
    } catch ({ name }) {
      this.hasData = false;
      this.message = '';
      this.systemError = name === 'TimeoutError' ? 'm014' : 'm017';
    } finally {
      this.filterConfig.isLoading = false;
    }
    const filters = {
      reports: 'report-transit',
    };
    this.googleAnalyticsService.sendCustomEvent('filter', filters);
  }

  /**
   * Function to set a tableDetails by config
   *
   * @param tableData table data
   */
  private setTableDetailsConfig(tableData: any): void {
    const headerParams: ITableHeaderParams = {
      data: tableData,
      excludeColumns: ['machineId', 'machineTypeId', 'zoneId', 'shiftId'],
      replaceColumnName: [
        { prevName: 'sectorName', newName: 'sector' },
        { prevName: 'zoneName', newName: 'zone' },
        { prevName: 'mapPoint', newName: 'point' },
        { prevName: 'machineTypeName', newName: 'machine_type' },
      ],
      sortables: ['machineName', 'machineTypeName', 'transitDate'],
    };

    const datasetParams: ITableDataParams = {
      tableData,
      excludeColumns: ['machineId', 'machineTypeId', 'zoneId', 'shiftId'],
      dateConfig: [{ field: 'transitDate', format: 'date-time' }],
    };

    const header = this.tableConfigService.setHeaderConfig(headerParams);
    const dataset = this.tableConfigService.setDatasetConfig(datasetParams);

    this.tableConfig = { header, dataset };
  }

  /**
   * Execute excel download
   */
  public downloadExcel(): void {
    const selectRangeDate = {
      startDate: this.datePipe.transform(this.params.startDate),
      endDate: this.datePipe.transform(this.params.endDate),
    };

    this.btnSpinner = true;
    this.disabledExcelBtn = true;
    this.reportTransitService.GetTransitReportExcel(this.params).subscribe({
      next: (response) => {
        this._excelExportService.exportAsExcel(response, 'rpt_transit', selectRangeDate, null, false);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastSuccess();
      },
      error: (error) => {
        console.error(error);
        this.btnSpinner = false;
        this.disabledExcelBtn = false;
        this._excelExportService.messageToastError();
      },
    });
  }
}
